import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-folder-icon',
  templateUrl: './folder-icon.component.html',
  styleUrls: ['./folder-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FolderIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
